import { Stack, Typography, Box } from "@mui/material";
import DefentSheet from "@/features/HealthScore/components/DefentSheet";
import theme from "@/theme";

interface InfoModalProps {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
  description: string;
  importanceTitle: string;
  unorderedList?: string[];
  textList?: string[];
}

export default function InfoModal({
  isOpen,
  handleClose,
  title,
  description,
  importanceTitle,
  unorderedList,
  textList,
}: InfoModalProps) {
  return (
    <DefentSheet
      expanded={isOpen}
      padding={0}
      onExpandedChange={(expanded) => {
        if (!expanded) {
          handleClose();
        }
      }}
      onClose={() => handleClose()}
    >
      <Stack width="100%">
        <Typography
          variant="h3"
          fontWeight={700}
          align="center"
          style={{ marginBottom: 25 }}
        >
          {title}
        </Typography>
        <Typography fontWeight={600} fontSize={16} style={{ marginBottom: 25 }}>
          {description}
        </Typography>
        <Stack
          direction="column"
          padding={2}
          spacing={2}
          sx={{
            borderRadius: 2,
            backgroundColor: theme.palette.grey[100],
          }}
        >
          <Typography fontWeight={600} fontSize={16} align="center">
            {importanceTitle}
          </Typography>
          {unorderedList && (
            <Box
              style={{
                paddingLeft: 16,
                paddingRight: 16,
                fontSize: 12,
              }}
            >
              <ul>
                {unorderedList.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </Box>
          )}
          {textList?.map((text, index) => (
            <Typography fontWeight={500} fontSize={12} key={index}>
              {text}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </DefentSheet>
  );
}
